import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.from";
import "core-js/modules/es.array.is-array";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.date.to-string";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/*
 * Copyright (c) 2020 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Ritika Khare
 */
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import Script from 'react-load-script';
import globals from '../../lib/globals/globals';
import NuanceChat from './NuanceChat';

var NuanceContainer = function NuanceContainer() {
  var _ref = globals().messengerWebSDK || {},
      enableNuanceWebSDKChat = _ref.enableNuanceWebSDKChat,
      loadNuanceWebSDK = _ref.loadNuanceWebSDK,
      loadAuxiWebSDK = _ref.loadAuxiWebSDK;

  var nuanceLoaded = useSelector(function (_ref2) {
    var core = _ref2.core;
    return core.nuance.nuanceCtaClicked;
  });
  var auxiWebsdkLoaded = useSelector(function (_ref3) {
    var core = _ref3.core;
    return core.nuance.auxiCtaClicked;
  });

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      bridgeLoaded = _useState2[0],
      setBridgeLoaded = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      nuanceBootstrapLoaded = _useState4[0],
      setNuanceBootstrapLoaded = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      nuanC2Loaded = _useState6[0],
      setNuanC2Loaded = _useState6[1];

  var onLoadBridge = function onLoadBridge() {
    return setBridgeLoaded(true);
  };

  var onLoadNuanceBootstrap = function onLoadNuanceBootstrap() {
    return setNuanceBootstrapLoaded(true);
  };

  var onLoadNuanC2 = function onLoadNuanC2() {
    return setNuanC2Loaded(true);
  }; // chatPersistence if true,loads the chat when navigating between modules


  var chatPersistence = loadNuanceWebSDK === true || loadAuxiWebSDK === true; // ctaClick tracks the click of CTA, which is set based on nuanceCtaClicked / auxiCtaClicked

  var ctaClick = 0;

  if (nuanceLoaded !== undefined || auxiWebsdkLoaded !== undefined) {
    ctaClick = nuanceLoaded > auxiWebsdkLoaded ? nuanceLoaded : auxiWebsdkLoaded; // chatPersistence should only hold true when user lands on the page, post first click it shoul be set to False

    chatPersistence = false;
  } // displayAuxiWebsdk if set to true, navigates to Auxi Bot


  var displayAuxiWebsdk = auxiWebsdkLoaded > 0 || loadAuxiWebSDK === true && chatPersistence;
  return enableNuanceWebSDKChat && (chatPersistence || ctaClick > 0) ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("link", {
    rel: "stylesheet",
    type: "text/css",
    href: globals().messengerWebSDK.c2cbuttonCSS
  }), /*#__PURE__*/React.createElement("link", {
    rel: "stylesheet",
    type: "text/css",
    href: globals().messengerWebSDK.chatCSS
  }), !window.WFUI_BRIDGE && /*#__PURE__*/React.createElement(Script, {
    url: globals().messengerWebSDK.wfBridgePath,
    onLoad: onLoadBridge
  }), !window.NuanMessaging && /*#__PURE__*/React.createElement(Script, {
    url: globals().messengerWebSDK.webSDKBootstrapJS,
    onLoad: onLoadNuanceBootstrap
  }), !window.BootStrapC2C && /*#__PURE__*/React.createElement(Script, {
    url: globals().messengerWebSDK.c2cJS,
    onLoad: onLoadNuanC2
  }), (bridgeLoaded || window.WFUI_BRIDGE) && (nuanceBootstrapLoaded || window.NuanMessaging) && (nuanC2Loaded || window.BootStrapC2C) && /*#__PURE__*/React.createElement(NuanceChat, {
    routeToAuxi: displayAuxiWebsdk,
    menuClick: !chatPersistence
  })) : null;
};

export default NuanceContainer;